import {Box, createStyles, Text} from '@mantine/core';
import React from 'react';

import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import getTestProps from 'test/lib/cypress/getTestProps';

import {countGraphemes} from './GraphemeLimit';

const useStyles = createStyles((theme, {atLimit, visible}: {atLimit: boolean; visible: boolean}) => ({
  root: {
    '& > .editable': {
      outline: visible ? `2px solid ${atLimit ? theme.colors.red[6] : theme.colors.orange[6]}` : undefined,
      outlineOffset: visible ? 2 : undefined,
    },
  },
  counter: {color: atLimit ? theme.colors.red[6] : theme.colors.orange[7]},
}));

const GRAPHEME_LIMIT_FEEDBACK_PERCENT = 0.9;

export default function GraphemeLimitFeedback({
  text,
  maxGraphemes,
  children,
}: {
  text: string;
  maxGraphemes: number;
  children: React.ReactNode;
}): JSX.Element {
  const {isPrintPreviewView} = EditorPropertiesContext.useContext();
  const count = countGraphemes(text);
  const atLimit = count >= maxGraphemes;
  const visible =
    !isPrintPreviewView && (atLimit || count >= Math.ceil(maxGraphemes * GRAPHEME_LIMIT_FEEDBACK_PERCENT));
  const {classes} = useStyles({atLimit, visible});
  return (
    <Box
      // Caller layout and styling stay on the editable child so they are not applied twice.
      className={classes.root}
      {...getTestProps({component: 'GraphemeLimitFeedback', element: 'root'})}
    >
      {children}
      {visible ? (
        <Text role="status" size="xs" className={classes.counter} mt="xs">
          {count} / {maxGraphemes} characters
        </Text>
      ) : null}
    </Box>
  );
}
